import React from 'react';
import {
  required, Toolbar, SaveButton, DateField, SimpleForm, ReferenceArrayInput, AutocompleteArrayInput, NumberInput,
  Edit, Filter, List, Datagrid, TextField, TextInput, NumberField
} from 'react-admin';

const OrderFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="search_name" alwaysOn resettable />
    <NumberInput label="Order ID" source="search_id" resettable />
    <ReferenceArrayInput source="publisher_id" label="Publisher"
      reference="publishers"
      basePath='publishers'
      perPage={10}
      sort={{ field: 'name', order: 'ASC' }}
      filterToQuery={searchText => ({ search_name: searchText })}
    >
      <AutocompleteArrayInput label="Publishers" optionText="name" optionValue="code" style={{ width: '90%' }} />
    </ReferenceArrayInput>
  </Filter>
);

export const OrderList = ({ permissions, ...props }) => (
  <List {...props} title="Orders"
    filters={<OrderFilter permissions={permissions} />}
    perPage={25}
    bulkActionButtons={false}
    exporter={false}>

    <Datagrid rowClick="edit" size='medium'>
      {permissions && permissions.role === 'admin' &&
        <TextField source="code" label="ID" />
      }
      <TextField source="name" label="Name" />
      <DateField source="start_date_time" label="Start Date" />
      <DateField source="end_date_time" label="End Date" />
      <NumberField source="totalImpressionsDelivered" label="Impressions Delivered" />
      <NumberField source="totalClicksDelivered" label="Clicks Delivered" />
    </Datagrid>
  </List>
);

const OrderTitle = ({ record }) => {
  return <span>Order {record ? `"${record.name}"` : ''} {record && record.active ? 'ACTIVE' : 'INACTIVE'}</span>;
};

const CustomToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
    <br />
    <DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
    <TextField source="updated_name" label="" style={{ padding: '10px' }} />
  </Toolbar>
);

export const OrderEdit = (props) => (
  <Edit title={<OrderTitle />} {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <TextField source="code" label="Order ID" validate={required()} />
      <TextField source="name" label="Order Name" style={{ width: '400px' }} validate={required()} />
      {props.permissions && props.permissions.role === 'admin' &&
        <ReferenceArrayInput source="publisher_id" label="Publisher" reference="publishers"
          perPage={20}
          sort={{ field: 'name', order: 'ASC' }}
          filterToQuery={searchText => ({ search_name: searchText })}
          allowEmpty emptyText="- None -">
          <AutocompleteArrayInput label="Publishers" optionText="name" optionValue="code" style={{ width: '90%' }} />
        </ReferenceArrayInput>
      }
    </SimpleForm>
  </Edit>
);
